<template>
    <div class="configure-container">
        <div class="configure-title-section">
            <div>
                <div class="back-link " @click="goBackClick()"> {{'< BACK'}} </div>
                <div class="configure-title">Configure Targets</div>
                <div class="configure-subtitle" style= "margin-left: 28px;font-weight:10px;padding-bottom:20px">Edit metric target</div>
            </div>
            <div style="margin-right: 20px;">
                <input type="text" placeholder="Search Target" v-model="searchTerm" class="search-metrics"/>
                <img  style="margin-top: 4px; margin-left: -40px; margin-right: 65px; padding: 10px 0px 14px;width:22px;" src="../assets/img/search-logo.png" alt="search-metrics"/>
            </div>
        </div>
        <div class="configure-view-section" :style="{height: `${maxHeight - 214}px`}">
            <div class="configure-read">
                <div class="metric-form">
                    <div class="form-field-aarp" style="width: 150px">
                        <div class="filter-label">Year</div>
                        <div style="width: 160px; display: flex;">
                            <div style="margin-bottom:28px; margin-left: 4px;margin-top: 6px;">
                                <datepicker :calendar-class="'vdp-datepicker'" input-class='datePicker-input-class' :value="modalSelectedYear" 
                                v-model="modalSelectedYear" :disabled="!years" placeholder="Select Year" @selected="setYear()" 
                                @opened="displayRequiredYears()" 
                                name="years"  :minimum-view="'year'" :format="'YYYY'" :maximum-view="'year'" 
                                :initial-view="'year'" :disabled-dates="disabledDates"></datepicker></div>
                            <div v-if="!years">
                                <img style="margin-top:6px; margin-left: 7px; width:26px;" src="../assets/img/ajax-loader.gif" alt="loading data..." />
                            </div>
                        </div>
                    </div>
                    <div class="form-field-aarp" style="width: 200px">
                        <div style="margin-bottom:4px; margin-left:70px;margin-top: 6px;" class="filter-label">Program Name</div>
                        <select style="margin-left:70px" class="form-control" :disabled="modalPrograms.length == 0" v-model="modalSelectedProgram">
                            <option value="">Select program name</option>
                            <option v-for="program in modalPrograms" :value="program" :key="program">{{program}}</option>
                        </select>
                    </div>
                    <div class="form-field-aarp" style="align-self: flex-end;">
                        <button style="margin-left:75px; margin-bottom: 27px;" @click="viewMetrics()" :disabled="!modalSelectedProgram || !modalSelectedYear" class="btn btn-warning-arp">View Targets</button>
                    </div>
                </div>
                <div class="metric-data-view" v-if="metricData">
                    <div v-if="false" class="metric-view" >
                        <div class="metric-view-title">
                            <div style="margin-right: 8px;">{{this.modalSelectedYear}}</div>
                            <div style="margin-right: 8px;"> | </div>
                            <div>{{this.modalSelectedProgram}}</div>
                        </div>
                        <div>
                            <!--<img src="../assets/img/edit-24px.svg" alt="edit img" />-->
                            <div class="back-link" style="font-size:15px;">CONFIGURE TARGETS</div>
                        </div>
                    </div>
                    <div v-if="hotSettings.data[0] === 'empty'" style="margin-top: 50px; margin-bottom: 30px;">
                        No Items to show...
                    </div>
                    <div v-else-if="hotSettings.data.length > 0" style="margin-top: 24px">
                        <HotTable :settings="hotSettings" ref="hotTableComponent" :style="{ height: `${maxHeight - 414}px`, overflow: 'auto'}" ></HotTable>
                        <!--
                        <div id="advanced-editor-example" class="hot">
                            <hot-table :settings="hotSettings">
                                <hot-column :width="150">
                                    <p hot-renderer>111</p>
                                </hot-column>
                                <hot-column v-for="n in 2" :width="150" v-bind:key="'col' + n">
                                    <p hot-renderer>222</p>                            
                                </hot-column>
                            </hot-table>
                        </div> -->
                    </div>
                    <div v-else-if="hotSettings.data.length === 0" style="margin-top: 50px; margin-bottom: 30px;">
                        Please Wait...
                    </div>
                </div>
            </div>
        </div>
        <div v-if="renderEditSection" class="modal-main">
            <div id="modalBody" :style="{top: mTop, left: mLeft}" class="modal-content">
                <div class="flex-general" style="align-items: center;">
                    <div style="font-size: 20px; font-weight: bold;">
                        Set Target
                    </div>
                    <div>
                        <span @click="clearTargetAddModal()" style="font-size:13px; color: #0A61B7; cursor: pointer; font-weight: bold;">CLEAR</span> <span style="margin-left: 20px;" class="close" @click="closeMetricEdit">&times;</span>
                    </div>
                </div>
                <div class="target-config-edit-note">
                    <span style="font-weight: bold;">NOTE:</span> Updating target will be applicable from the effective date.
                </div>
                <div style="border-top: 2px solid #eeeeee; margin: 5px; width: 92%;"></div>
                 <div class="flex-general" style="flex-direction: column;">
                    <div class="flex-general" style="flex-direction: row;">
                        <div @click="handleTargetOptionSelection(1, 'over')" id="over" class="target-select-options">
                            <div> {{'&#8805'}} </div>
                            <div class="selection-options-text"> Greater than or equal to </div>
                        </div>
                        <div @click="handleTargetOptionSelection(-1, 'under')" id="under" class="target-select-options">
                            <div> {{'&#8804'}} </div>
                            <div class="selection-options-text"> Less than or equal to </div>
                        </div>
                        <div @click="handleTargetOptionSelection(0, 'no_target')" id="no_target" class="target-select-options" style="justify-content: center;">
                            <div> {{'&#47'}} </div>
                            <div class="selection-options-text"> No Target </div>
                        </div>
                    </div>
                </div>
                 <div class="flex-general" style="flex-direction: column; width: 120px;">
                        <p style="margin-bottom: 4px; font-size: 75%; font-weight: bold;">Value</p>  
                        <div class="">
                            <input style="width: 170px;" class="form-control" v-model="targetInput" />                            
                              <div v-if="updationProgressStatus"><img style="margin-top: -68px; margin-left: 190px;width:26px;" src="../assets/img/ajax-loader.gif" alt="loading data..." />
                            </div>
                        </div>
                       
                    </div>
                <div style="border-top: 2px solid #eeeeee; margin: 5px; width: 92%;"></div>

                <div class="flex-general">
                     <button @click="closeMetricEdit()" class="btn btn-action-arp">Cancel</button>
                        <button @click="metricTargetSubmit()" class="btn btn-warning-arp" style="width: 130px;">Save</button>
                </div>
                <div>
                    
                </div>
                <div>
                    
                </div>
            </div>
        </div>
        <div v-if="false" class="modal-main">
            <div id="modalBody" :style="{top: mTop, left: mLeft}" class="modal-content">
                <div class="flex-general" style="align-items: center;">
                    <div style="font-size: 23px; font-weight: bold;">
                        Set Target
                    </div>
                    <div>
                        <span style="color: #0A61B7; font-weight: bold;">Clear</span> <span style="margin-left: 20px;" class="close" @click="closeMetricEdit">&times;</span>
                    </div>
                </div>
                <div style="border-top: 2px solid #eeeeee; margin: 5px; width: 92%;"></div>
               <div class="flex-general">
                    <div class="flex-general" style="flex-direction: column; width: 120px;">
                        <p style="margin-bottom: 0;">From</p>  
                        <div class="">
                            <select class="form-control" v-model="selectedFromMonth">
                                <option v-for="(month,index) in monthsArray" :key="month" :value="month">{{month}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="flex-general" style="flex-direction: column;">
                        <p style="margin-bottom: 0;">Till</p>
                        <div class="">
                             <select class="form-control" v-model="selectedTillMonth">
                                <option v-for="(month,index) in monthsArray" :key="month" :value="month">{{month}}</option>
                            </select>
                        </div>
                    </div>
                </div>
                 <div class="flex-general" style="flex-direction: column;">
                    <div>
                        Select
                    </div>
                    <div class="flex-general" style="flex-direction: row;">
                        <div class="target-select-options">
                            <div> > </div>
                            <div class="selection-options-text"> Greater than </div>
                        </div>
                        <div class="target-select-options">
                            <div> < </div>
                            <div class="selection-options-text"> Less than </div>
                        </div>
                        <div class="target-select-options">
                            <div> / </div>
                            <div class="selection-options-text"> No Target </div>
                        </div>
                    </div>
                </div>
                <div style="border-top: 2px solid #eeeeee; margin: 5px; width: 92%;"></div>

                <div class="flex-general">
                     <button @click="closeMetricEdit()" class="btn btn-action-arp">Cancel</button>
                        <button @click="closeMetricEdit()" class="btn btn-warning-arp" style="width: 130px;">Save</button>
                </div>
                <div>
                    
                </div>
                <div>
                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { HotTable, HotColumn } from '@handsontable-pro/vue';
import { mapActions, mapGetters } from 'vuex';
import Handsontable from 'handsontable-pro';
import "handsontable-pro/dist/handsontable.full.css";
import { parse } from 'path';
import Datepicker from '@hokify/vuejs-datepicker';
import { LICENSE_KEY } from "../Constants"

const editImageSource = 'src/assets/img/edit-24px.svg';

export default {
  name: "MetricConfiguration",
  components: {
        HotTable,
        HotColumn,
        'datepicker':Datepicker,
        },
  methods: {
       ...mapActions(['login','getMetricData','updateGetMetricParams','updateComments','updateOverlayParams','initDeleteComment','updateCommentaryParams','postEditComment','getMenuOptions','resetOverlay', 'editTargetData']),
      goBackClick() {
            this.$router.push({name: 'Configuration'});
      },
      viewMetrics() {
          if (this.modalSelectedYear && this.modalSelectedProgram) {
              this.hotSettings.data = [];
              this.updateGetMetricParams({program: this.modalSelectedProgram, year: new Date(this.modalSelectedYear).getUTCFullYear().toString()});
              this.getMetricData();
              this.metricData = true;
          }
      },
      clearTargetAddModal() {
          this.resetOptionFocus("");
          this.targetInput = 0;
          this.handleTargetOptionSelection(0, 'no_target');
          /*
          let data = [...this.hotSettings.data];
          this.hotSettings.data = [...data];
          data = undefined;
          */
      },
      resetOptionFocus(e) {
          const options = ['under', 'over', 'no_target'];
          options.filter(el => el!==e).forEach(i => {
              const ele = document.getElementById(i);
              ele.style.border = "1px solid #c0c0c0";
              ele.style.backgroundColor = "#ffffff";
              ele.style.color = "#000000";
          });
      },
      setYear()
         { 
            this.modalSelectedYear=new Date().getUTCFullYear().toString();
         },
         displayRequiredYears(){
        let years=JSON.stringify(Object.keys(this.years))
        this.disabledDates.customPredictor= function(date) {
                 if(years.toString().includes(date.getFullYear())){
                    return false;
                }
                else{
                    return true;
                }
        }
    
    },
      metricTargetSubmit() {
          /*{
            "start": "august",
            "target_type": "under",
            "value": "200"
        }*/
        const index = this.renderAddTargetForIndex['row'];
        const rowData = this.hotSettings.data[index];
        let data = {
            metric_name: rowData.metricName,
            value: this.targetInput,
            start: ["","January","February","March","April","May","June","July",
            "August","September","October","November","December"][this.renderAddTargetModalForIndex['col']].toLowerCase(),
            target_type: this.selectedTargetOption === 0 ? 'no_target' : this.selectedTargetOption > 0 ? 'over' :'under'
        }
        if (data.target_type === 'no_target') {
            // delete data['value'];
        }

        const onDialogClose = () => {
            this.selectedTargetOption = "";
            this.renderAddTargetForIndex = {};
            this.renderAddTargetModalForIndex = {};
            this.targetInput = "";
            this.renderEditSection = false;
        }

        if(this.oldtargetInputValue !== this.targetInput || this.oldSelectedTargetOptionValue!== data.target_type) {
        this.editTargetData(data);
        setTimeout(onDialogClose, 600);
        } else {
            onDialogClose();
        }
       
      },
      handleTargetOptionSelection(e, selector) {
          this.resetOptionFocus(selector);
          const ele = document.getElementById(selector);
          // ele.style.border = "1px solid blue";
          ele.style.backgroundColor = "#0A61B7";
          ele.style.color = "#ffffff";
          this.selectedTargetOption = e;
      },
      doIt(e, b, c) {
            this.renderEditSection = true;
            this.mTop = "332px";
            this.mLeft = "452px";
            this.handleFirstClick(b)
        },
        deleteMetric() {
            this.resetOverlay();
            this.updateOverlayParams({
                display: 'block',
                title: 'Delete Metric',
                message: 'Are you sure you want to delete this metric?',
                isNotification: false,
                buttons: {
                    type: 'challenge',
                    successHandler: () => {
                     // 
                    }
                },
                specialClassNames: 'delete-comment',
                duration: '',
                displayCloseIcon: true,
                background: true
            });
        },
    closeMetricEdit() {
        this.renderAddTargetModalForIndex = {};
        this.renderAddTargetForIndex = {};
        this.renderEditSection = false;
    },
    targetCellRenderer(instance, td, row, col, prop, value, cellProperties) {
        Handsontable.renderers.TextRenderer.apply(this, arguments);
        let escaped = Handsontable.helper.stringify(value);
        //td.innerHTML = value == 0 ? `<div class="myBt config-target-add"> + </div>` : `<div style="display: flex;flex-direction: row; justify-content: end;"> <div> ${value} </div> </div>`;
            td.innerHTML = `<div class="config-target-add-main" style="display: flex;flex-direction: row; justify-content: end;"> <div id="tc-v"> ${value} </div> <div id="tc-a" class="config-target-add myBt"><div class="myBt33">+</div></div></div>`;
    return td;
    },
    handleFirstClick(cords) {
        var htTable =  this.$refs.hotTableComponent.hotInstance.getInstance();
        this.renderAddTargetForIndex['row'] = htTable.toPhysicalRow(cords.row);
        this.renderAddTargetForIndex['col'] = cords.col;
        const data = {...this.renderAddTargetForIndex};
        this.renderAddTargetForIndex = {...data};
        this.handleSecondClick(cords)
    },
    handleSecondClick(cords) {
        var htTable =  this.$refs.hotTableComponent.hotInstance.getInstance();
        this.renderAddTargetModalForIndex['row'] = htTable.toPhysicalRow(cords.row);
        this.renderAddTargetModalForIndex['col'] = cords.col;
        const data = {...this.renderAddTargetModalForIndex};
        this.renderAddTargetModalForIndex = {...data};
        let currentRow = this.hotSettings.data[htTable.toPhysicalRow(cords.row)];
        let currentMonth =  ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][cords.col];
        const target = currentRow[(cords.col) + '-target_type'];
        setTimeout(() => {
            this.handleTargetOptionSelection(target, target);
        }, 100);
        this.targetInput = currentRow[currentMonth];
        this.oldtargetInputValue=this.targetInput;
        this.oldSelectedTargetOptionValue=target;
    },
    searchInResults: function(searchTerm) {
       if(this.hotSettings.data!=='undefined' && this.hotSettings.data.length>0)
       {
           if(searchTerm.length>0)
           {
                const filtersPlugin = this.$refs.hotTableComponent.hotInstance.getPlugin('filters');
                filtersPlugin.removeConditions(0);
                filtersPlugin.filter();
                filtersPlugin.addCondition(0, 'contains', [searchTerm]);
                filtersPlugin.filter();
                var htTable =  this.$refs.hotTableComponent.hotInstance.getInstance();
                             if(htTable.countVisibleRows()==0)
               {
                     this.$notify({
                        group: 'error',
                        text: 'Result not found...',
                        closeOnClick:true
                        });
               }
           }
           else
           {
                const filtersPlugin = this.$refs.hotTableComponent.hotInstance.getPlugin('filters');
                filtersPlugin.removeConditions(0);
                filtersPlugin.filter();
           }
       }
       else{
            if(searchTerm.length>0)
           {
            this.$notify({
                            group: 'error',
                            text: 'Select year and program name for searching...',
                            closeOnClick:true
                            });
            }
      } 
    },
    expCellRenderer(instance, td, row, col, prop, value, cellProperties) {
        Handsontable.renderers.TextRenderer.apply(this, arguments);
        let escaped = Handsontable.helper.stringify(value);
        //td.innerHTML = value == 0 ? `<div class="myBt config-target-add"> + </div>` : `<div style="display: flex;flex-direction: row; justify-content: end;"> <div> ${value} </div> </div>`;
            td.innerHTML = !(this.renderAddTargetForIndex.row === row && this.renderAddTargetForIndex.col === col)? `<div class="test-cell-renderer config-target-add-main" style="display: flex;flex-direction: row; justify-content: end; cursor: pointer;"> <div id="tc-v"> ${value} </div><div id="tc-a" class="config-target-add second-click-cell myBt"><div class="myBt">+</div></div></div>` : !(this.renderAddTargetModalForIndex.row === row && this.renderAddTargetModalForIndex.col === col) ? `<div class="" style="display: flex;flex-direction: row; justify-content: end;"> <div id="tc-a" class="second-click-cell config-target-add myBt1"><div class="myBt">+</div></div></div>` : `<div class="" style="display: flex;flex-direction: row; justify-content: end;"> <div id="tc-a" class="target-config-modal-open config-target-add-2 myBt"><div class="myBt">+</div></div></div>`;
    return td;
    },
  },
  
  data: function() {
    let _this = this;
    return {
        maxHeight: innerHeight,
        renderAddTargetForIndex: {},
        renderAddTargetModalForIndex: {},
        searchTerm: '',
        years: false,
        mTop: '0',
        mLeft: '0',
        modalPrograms: '',
        targetInput: '',
        monthsArray: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'], 
        selectedFromMonth: '',
        selectedTargetOption: '',
        selectedTillMonth: '',
        categoryValue: 'Billing, Enrollment',
        decimalValue: 12,
        modalSelectedYear: '',
        modalSelectedProgram: '',
        metricData: false,
        renderEditSection: false,
        oldtargetInputValue:0,
        oldSelectedTargetOptionValue:'',
        currentSelectedYear:'',
        disabledDates:{ customPredictor: function(date) {
            let years=JSON.stringify(Object.keys(this.years))
                if(typeof years!=='undefined'){
            if(years.toString().includes(date.getFullYear())){
                    return false;
                }
                else{
                    return true;
                }
            }}},
        target: {},
        sortState: null,
        hotSettings: {
                data: [
                    /*
                    ['t', '12', 'A', '2.34'],
                    ['t', '12', 'A', '2.34'],

                    ['t', '12', 'A', '2.34'],

                    {
                        metricName: 'Test',
                        Jan: 1,
                        Feb: 2,
                        Mar: 3,
                        Apr: 4,
                        May: 5,
                        Jun: 6,
                        Jul: 7,
                        Aug: 8,
                        Sep: 9,
                        Oct: 10,
                        Nov: 11,
                        Dec: 12
                    }
                    */
                ],
                licenseKey: LICENSE_KEY,
                stretchH: 'all',
                manualColumnResize: true,
                colHeaders: ['Metric Name', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],  
                columnSorting: true,
                columnSorting: {
                    indicator: true,
                    initialConfig: null
                },
                afterColumnSort(currentSortConfig, destinationSortConfigs) {
                    _this.sortState = destinationSortConfigs[0];
                },
                columns: [
                    {
                        data: 'metricName',
                        readOnly: true,
                        width: 200,
                        editor: false
                    },
                    {
                        data: 'Jan',
                        readOnly: true,
                        renderer: this.expCellRenderer, //(instance, td, row, col, prop, value, cellProperties),
                        editor: false
                    },
                    {
                        data: 'Feb',
                        readOnly: true,
                        renderer: this.expCellRenderer,
                        editor: false
                    },
                     {
                        data: 'Mar',
                        readOnly: true,
                        renderer: this.expCellRenderer,
                        editor: false
                    },
                    {
                        data: 'Apr',
                        readOnly: true,
                        renderer: this.expCellRenderer,
                        editor: false
                    },
                    {
                        data: 'May',
                        readOnly: true,
                        renderer: this.expCellRenderer,
                        editor: false
                    },
                    {
                        data: 'Jun',
                        readOnly: true,
                        renderer: this.expCellRenderer,
                        editor: false
                    },
                     {
                        data: 'Jul',
                        readOnly: true,
                        renderer: this.expCellRenderer,
                        editor: false
                    },
                    {
                        data: 'Aug',
                        readOnly: true,
                        renderer: this.expCellRenderer,
                        editor: false
                    },
                    {
                        data: 'Sep',
                        readOnly: true,
                        renderer: this.expCellRenderer,
                        editor: false
                    },
                    {
                        data: 'Oct',
                        readOnly: true,
                        renderer: this.expCellRenderer,
                        editor: false
                    },
                     {
                        data: 'Nov',
                        readOnly: true,
                        renderer: this.expCellRenderer,
                        editor: false
                    },
                    {
                        data: 'Dec',
                        readOnly: true,
                        renderer: this.expCellRenderer,
                        editor: false
                    },
                ],
                afterOnCellMouseDown: function(event, cords, TD) {
                    if (event.realTarget.className.indexOf('test-cell-renderer') < 0 && event.realTarget.className.indexOf("second-click-cell") < 0 && event.realTarget.className.indexOf('myBt') < 0 &&event.realTarget.className.indexOf('myBt33') < 0 &&
                     event.realTarget.className.indexOf('delete') < 0) {
                        return;
                    }
                    event.realTarget.className.indexOf("second-click-cell") > -1 && _this.handleSecondClick(cords);
                    event.realTarget.className.indexOf("myBt33") > -1 && _this.handleSecondClick(cords);
                    event.realTarget.className.indexOf('test-cell-renderer') > -1 && _this.handleFirstClick(cords);
                    event.realTarget.className.indexOf('myBt') > -1 && _this.doIt(event, cords, TD);
                    event.realTarget.className.indexOf('delete') === 0 && _this.deleteMetric();
                },
                renderer: 'html',
                autoRowSize: false,
                autoColumnSize: false,
                disableVisualSelection: true,
                filters: true
            },
    };
  },
  computed: mapGetters(['currentCommentsMainCategory','currentCommentsSubCategory','currentCommentsYear','currentMetricData','currentCommentsPeriod','currentCommentsData','isLoggedIn','currentUserName','currentUserEmail','currentUserGroups','currentAccessLevel','currentCommentaryMenu','updationProgressStatus']),
  watch: {
      renderAddTargetForIndex: function() {
          let data = [...this.hotSettings.data];
          this.hotSettings.columnSorting.initialConfig = this.sortState;
          this.hotSettings.data = data;
          data = undefined;
      },
      renderAddTargetModalForIndex: function() {
          let data = [...this.hotSettings.data];
          this.hotSettings.columnSorting.initialConfig = this.sortState;
          this.hotSettings.data = data;
          data = undefined;
      },
      currentMetricData: function() {
           const mkeys = Object.keys(this.currentMetricData);
           let dd = [];
           const months = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
           const reqFields = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
           console.log('-----', this.currentMetricData)
            if(Object.keys(this.currentMetricData).length > 0) {
                mkeys.forEach((i, index) => {
                    /*
                    start : "january"
                    target_type : "no_target"
                    end : "december"
                    value : "0.0"
                    */
                   let obj = {};
                    obj.category = this.currentMetricData[i].metric_category;
                    obj.decimals = (parseFloat(this.currentMetricData[i].metric_target[0].value)).toString();
                    obj.metricName = mkeys[index];
                   this.currentMetricData[i].metric_target.forEach((t) => {
                        let startIndex = months.indexOf(t.start.toLowerCase());
                        let endIndex = months.indexOf(t.end.toLowerCase());
                        //obj.status = 'Active';
                        reqFields.forEach((f, fIndex) => {
                            if (fIndex >= startIndex && fIndex <= endIndex) {
                                obj[f] = (parseFloat(t.value)).toString();
                                obj[`${fIndex + 1}-target_type`] = t['target_type']
                            } else {
                               // obj[f] = "NULL"
                            }
                        });
                   });
                    dd.push(obj);
                   /*
                   let startIndex = months.indexOf(this.currentMetricData[i].metric_target[0].start.toLowerCase());
                   let endIndex = months.indexOf(this.currentMetricData[i].metric_target[0].end.toLowerCase());
                    let obj = {};
                    obj.category = this.currentMetricData[i].metric_category;
                    obj.decimals = (parseFloat(this.currentMetricData[i].metric_target[0].value)).toString();
                    obj.metricName = mkeys[index];
                    //obj.status = 'Active';
                    reqFields.forEach((f, fIndex) => {
                        if (fIndex >= startIndex || fIndex <= endIndex) {
                            obj[f] = (parseFloat(this.currentMetricData[i].metric_target[0].value)).toString();
                            obj[`${fIndex + 1}-target_type`] = this.currentMetricData[i].metric_target[0]['target_type']
                        } else {
                            obj[f] = "NULL"
                        }
                    })
                    dd.push(obj)*/
                });
                this.hotSettings.columnSorting.initialConfig = this.sortState;
                this.hotSettings.data = [...dd];
                dd = undefined;
            } else {
                this.hotSettings.data = ['empty'];
            }
        },
      currentCommentaryMenu: function(){
          let allYears = Object.keys(this.currentCommentaryMenu);
          let currentYear = new Date().getFullYear();
          allYears = allYears.filter(i => i >= currentYear);
          let yearsCollection = {};
          allYears.forEach(i => {
              yearsCollection[i] = this.currentCommentaryMenu[i];
          });
          this.years = { ...yearsCollection};
          allYears = undefined;
          currentYear = undefined;
          yearsCollection = undefined;
        },
         searchTerm: function()
      {
          this.searchInResults(this.searchTerm);
      },
      modalSelectedYear: function(){
            this.modalPrograms = [];
            if (this.modalSelectedYear != 'undefined'){
                let selectedDate=new Date(this.modalSelectedYear).getUTCFullYear().toString()
                if(selectedDate.length > 0){
                this.modalPrograms = this.years[selectedDate]['Providers'];
                 this.currentSelectedYear=new Date(selectedDate, 1, 1);
                }
            }
        },
  },
  created(){
        this.years = (Object.keys(this.currentCommentaryMenu).length > 0 ? this.currentCommentaryMenu : false);
        let target = this.$route.params.data && JSON.parse(this.$route.params.data);
        if (target) {
            this.target = {...target}
            this.modalSelectedYear = new Date(target.year, 1, 1);
            this.modalPrograms = this.years[new Date(this.modalSelectedYear).getUTCFullYear().toString()]['Providers'];
            setTimeout(() => {
                this.modalSelectedProgram = target.program;
                this.viewMetrics();
            }, 0);
        } else {
            this.getMenuOptions();
        }
  }
};
</script>

<style>
.config-target-add-main:hover #tc-v {
    display: none;
}
.config-target-add-main:hover #tc-a {
    display: flex;
}
.config-target-add-main #tc-a {
    display: none;
}
.config-target-add {
    cursor: pointer;
    color: #0A61B7;
    background-color: #eeeeee;
    font-weight: bold;
    width: -webkit-fill-available;
    display: flex;
    align-items: center;
    justify-content: center;
}
.config-target-add-2 {
    cursor: pointer;
    color: #ffffff;
    background-color: #0A61B7;
    font-weight: bold;
    width: -webkit-fill-available;
    display: flex;
    align-items: center;
    justify-content: center;
}
.false-config-target-add:hover {
    color: #ffffff;
    background-color: #0A61B7;
}
.target-config-modal-open {
    color: #ffffff;
    background-color: #0A61B7;
}
</style>

<style scoped>

.target-config-edit-note {
    padding: 0 5px;
    font-size: 70%;
    color: #808080;
}

/* The Modal (background) */
.modal-main {
  display: block; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 9999; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
}

.target-select-options {
    cursor: pointer;
    height: 42px;
    width: 82px;
    padding: 6px;
    border: 1px solid #c0c0c0;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.selection-options-text {
    line-height: 9px;
    font-size: 9px;
    margin-left: 7px;
    text-align: center;
}

/* Modal Content */
.modal-content {
  background-color: #fefefe;
  padding: 20px;
  border: 1px solid #888;
  width: 325px;
  position: absolute;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.flex-general {
    padding: 5px;
    width: 100%;
    display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

/* The Close Button */
.close {
  color: #000000;
  float: right;
  right: 10px;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
.selection-item {
    font-size: 14px;
}
.decimal-box {
    display: flex;
    border: 1px solid #C0C0C0;
}
.decimal-action-button {
    width: 60px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #E7EAF2;
    cursor: pointer;
    font-size: 18px;
    font-weight: bold;
}
.decimal-input {
    width: 130px;
    height: 40px;
    text-align: center;
}
.category-input {
    width: 250px;
}
.edit-selection {
    display: flex;
    flex-direction: row;
    margin-top: 25px;
}
.metric-edit-main {
    display: flex;
    flex-direction: column;
    margin-top: 28px;
}
.configure-read {
    width: 100%;
    padding-top: 24px;
    padding-left: 24px;
    padding-right: 24px;
    background-color: #F4F4F4;
    height: inherit;
    overflow-y: auto;
    max-height: 800px;
}
.configure-write {
    width: 500px;
    padding: 20px;
    /* margin-top: 16px; */
    border-left: 2px solid #C0C0C0;
    height: inherit;
    padding-top: 24px;
    padding-left: 24px;
    padding-right: 24px;
    background-color: #EEEEEE;
}
.handsontable .decimal-cell {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
.metric-data-view {
    margin-top: 30px;
}
.metric-view {
    display: flex;
    justify-content: space-between;
    width: 100%;
}
.metric-view-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
    font-size: 18px;
 }
.form-field-aarp {
    margin-right: 24px;
}
.metric-form {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
}
.btn-action-arp {
    color: #000 !important;
    background-color: rgb(255, 255, 255) !important;
    font-weight: bold !important;
    height: 34px;
    bottom: -2px;
    position: relative;
    padding: 3px 10px;
    width: 150px;
    border-radius: 5px;
}
.btn-warning-arp {
    color: #000 !important;
    background-color: #FBC743 !important;
    font-weight: bold !important;
    height: 34px;
    bottom: -2px;
    position: relative;
    padding: 3px 10px;
    width: 150px;
    border-radius: 5px;

}
.filter-label {
    font-weight: bold;
    margin-bottom: 2px;
    margin-top: 26px;
}
.form-title {
    font-size: 18px;
    font-weight: bold;
    padding-bottom: 20px;
    border-bottom: 2px solid #eeeeee;
    margin-bottom: 20px;
}
.search-metrics {
    border-radius: 30px;
    width: 300px;
    padding-left: 20px;
    border: 0;
    border: 1px solid #B1B9BE;
    height: 40px;
}
.search-metrics:focus {
    outline: none;
}
.back-link {
    color: rgb(43, 119, 155);
    cursor: pointer;
    padding: 3px 10px;
    font-size: 15px;
    font-weight: bold;
    margin-left: 20px;
    margin-top: 20px;
}
.configure-container {
  font-family: Arial;
  font-size: 16px;
  height: 100%;
}
.configure-title-section {
  top: 60px;
  left: 0px;
  width: 100%;
  height: 130px;
  background: #ffffff 0% 0% no-repeat padding-box;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.configure-title {
  margin-left: 28px;
  font-size: 26px;
  font-weight: 300;
  margin-top: 10px;
}
.configure-view-section {
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  background-color: #eeeeee;
  margin: 0;
  padding: 0;
  /* height: 82vh; */;
}
</style>
